// Supply WorkOrderPackingSlips (Phase 4 OM 2026-06-03) — EN + TR.
//
// S8 invariant: variant labels are PEXIFY-perspective; no producer name
// (Mehmet/Aybars) baked into visible strings.

import type { LocalizedDict } from '../index'

type PackingSlipsStrings = {
  title: (count: number) => string
  subtitle: string
  loading: string
  errorTitle: string
  variantLabels: {
    mehmet_minimal: string
    aybars_full: string
  }
  containsPii: string
  generatedAt: (when: string) => string
  downloadButton: string
  downloadMockTitle: string
  downloadMockDesc: string
  v15Note: string
}

export const workOrderPackingSlipsI18n: LocalizedDict<PackingSlipsStrings> = {
  en: {
    title: (count) => `Packing slips (${count})`,
    subtitle: 'Persona-filtered (S8)',
    loading: 'Loading slips…',
    errorTitle: 'Could not load packing slips.',
    variantLabels: {
      mehmet_minimal: 'Supplier slip (minimal)',
      aybars_full: 'NJ warehouse slip (full)',
    },
    containsPii: 'Contains customer PII',
    generatedAt: (when) => `Generated: ${when}`,
    downloadButton: 'Download PDF',
    downloadMockTitle: 'V1 simulation — no real PDF',
    downloadMockDesc:
      'PDF rendering is backend work (M3 Stage 4 Faz 3). Slip metadata is shown above; real blobs will be served once the print pipeline ships.',
    v15Note:
      'V1: backend renders 2 PDFs with Drive ACL gating. V1.5+ Wave-16 backlog: single doc + role-based section masking.',
  },
  tr: {
    title: (count) => `Paketleme fişleri (${count})`,
    subtitle: 'Persona ile filtrelendi (S8)',
    loading: 'Fişler yükleniyor…',
    errorTitle: 'Paketleme fişleri yüklenemedi.',
    variantLabels: {
      mehmet_minimal: 'Tedarikçi fişi (minimal)',
      aybars_full: 'NJ depo fişi (tam)',
    },
    containsPii: 'Müşteri PII içerir',
    generatedAt: (when) => `Oluşturulma: ${when}`,
    downloadButton: 'PDF indir',
    downloadMockTitle: 'V1 simülasyon — gerçek PDF yok',
    downloadMockDesc:
      "PDF üretimi backend işi (M3 Stage 4 Faz 3). Şu an sadece fiş üst verisi yukarıda görünür; gerçek blob yazdırma hattı kurulunca servis edilecek.",
    v15Note:
      'V1: backend 2 PDF üretir + Drive ACL erişim kontrolü. V1.5+ Wave-16 backlog: tek doküman + rol bazlı bölüm maskeleme.',
  },
}
